import type { persist as persistEn } from '../en/persist';

export const persist: typeof persistEn = {
  title: 'Evite que se borre su registro',
  body: (n: number) =>
    `Tiene ${n} ${n === 1 ? 'registro guardado' : 'registros guardados'} en este teléfono. A veces los teléfonos borran datos por su cuenta para liberar espacio. Puede pedirle a su navegador que no toque esta aplicación.`,
  whatHappensNext: 'Su navegador le pedirá confirmación. Elija Permitir.',
  confirm: 'Proteger mi registro',
  asking: 'Solicitando…',
  notNow: 'Ahora no',
  granted: 'Su registro está protegido en este teléfono.',
  declined:
    'No hay problema. Puede activarlo cuando quiera en Configuración, y guardar un archivo de respaldo funciona igual de bien.',
};
